import React from 'react';
import Container from '@material-ui/core/Container';
import {
  Theme,
  makeStyles,
} from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';

const useStyles = makeStyles((theme: Theme) => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    alignItems: 'center',
    justifyContent: 'flex-start',
    // backgroundImage: 'linear-gradient(to top, #151719, #7c8792)',
    // backgroundRepeat: 'no-repeat',
    // backgroundSize: 'cover',
  },
  card: {
    marginTop: theme.spacing(2),
    minWidth: 300,
  },
}));

interface FormLayoutProps {
  children: React.ReactNode;
  title?: string;
}

/**
 * Base layout in case of Form.
 */
const FormLayout = ({ children, title }: FormLayoutProps) => {
  const classes = useStyles();
  return (
    <Container maxWidth={false} className={classes.main}>
      <Card className={classes.card}>
        { title && <CardHeader title={title} /> }
        {children}
      </Card>
    </Container>
  );
};

export default FormLayout;
